export const STATUS_COLORS = {
  dispatched: '#3B82F6', // Blue
  completed: '#10B981', // Green
  cancelled: '#EF4444', // Red
  new: '#F59E0B', // Amber
  conducted: '#F59E0B', // Amber
}
